import React from 'react';

export default function TopMenu({children}) {
    return <div style={{
        padding: '20px 0'
    }}>
        {children}
    </div>
}